// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../constants/routes';
import styles from './styles.module.scss';

const menuLinks = [
  { name: 'Profile', use: 'black', linkTo: routes.app.profile.root },
];

type Props = {
  isVisible: boolean,
  setVisible: (boolean) => void,
  logout: () => void;
  isPlo5: boolean,
}

const ProfileMenu = ({
  isVisible, setVisible, logout, isPlo5,
}: Props) => {
  const applyPlo = (link: any) => (
    `${link}?isPlo5=${isPlo5}`
  );

  return (
    isVisible && (
      <nav id="profile-menu" aria-label="My Account" className={styles.menuContainer}>
        {menuLinks.map((link) => (
          <Link
            key={link.name}
            to={applyPlo(link.linkTo)}
            className={styles.menuItem}
            onClick={() => setVisible(false)}
          >
            {link.name}
          </Link>
        ))}
        <button
          type="button"
          className={`${styles.menuItem} ${styles.logout}`}
          onClick={() => {
            logout();
            setVisible(false);
          }}
        >
          Logout
        </button>
      </nav>
    )
  );
};

export default ProfileMenu;
